import { StyleSheet } from 'aphrodite';
import DIMENSIONS from '../../library/dimensions';

const styles = StyleSheet.create({
  root: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    flex: 1,
    maxWidth: DIMENSIONS.contentWidth,
    margin: '0 auto',
    paddingBottom: 64
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/layout/layout-styles.js